@if (areaService.accNameStatus().status !== 'Loaded') {
<acc-loading-part></acc-loading-part>
}

@else {
<div class='acc-delivery-page'>

	<toolbar icon='Delivery'>

		<button class="btn btn-light" (click)='areaService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i
				class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<div style='display:inline-block;width:400px'>
			<accelerator-droplist></accelerator-droplist>
		</div>

	</toolbar>

	<page-tabs [tabNames]='["Delivery", "Curriculum", "Graduation", "Awards"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>

		<ng-template pageTab1>
			<acc-delivery-views-part></acc-delivery-views-part>
		</ng-template>

		<ng-template pageTab2>
			<acc-delivery-curriculum-tab-part></acc-delivery-curriculum-tab-part>
		</ng-template>

		<ng-template pageTab3>
			<acc-delivery-graduation-tab-part></acc-delivery-graduation-tab-part>
		</ng-template>

		<ng-template pageTab4>
			<acc-delivery-awards-tab-part></acc-delivery-awards-tab-part>
		</ng-template>

	</page-tabs>

</div>
}